import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { toNumber } from "../../components/Common";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import Icon from "@material-ui/core/Icon";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";

// Material UI

// Redux Actions
import { updateAreaSpecificationShape } from "../../redux_store/jobState";
import { update2DDesigner } from "../../redux_store/appState";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import { UPDATE_DESIGN_PARAMETERS, updateJobState } from "../../redux_store/jobState";

import BSL_Dialog from "../../components/BSL_Dialog";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_TextInput from "../../components/BSL_TextInput";
import BSL_Button from "../../components/BSL_Button";

const toolDrawerWidth = 240;
const chip_width = "1rem";

// RoofSheet Specification

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            maxWidth: "400px",
            minWidth: "165px",
            padding: "0px 8px 8px 8px",
        },
        drawer: {
            width: toolDrawerWidth,
            flexShrink: 0,
            whiteSpace: "nowrap",
        },
        toolDrawerOpen: {
            // backgroundColor: "rgba(242,245,251, 0.5)",
            backgroundColor: "rgba(20,20,20, 0.5)",
            width: toolDrawerWidth,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        toolDrawerClose: {
            backgroundColor: "rgba(20,20,20, 0.5)",
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: "hidden",
            width: theme.spacing(7 + 1),
            [theme.breakpoints.up("sm")]: {
                width: theme.spacing(7 + 1),
            },
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px",
            minHeight: "48px",
            ...theme.mixins.toolbar,
        },
        toolMenuText: {
            color: "white",
            textAlign: "right",
        },
        toolMenuOn: {
            color: "orange",
            textShadow: "0px 0px 7px rgba(107,107,107,0.89)",
        },
        toolMenuOff: {
            color: "white",
            textShadow: "0px 0px 7px rgba(107,107,107,0.89)",
        },
        toolListItem: {
            paddingRight: "0px",
            minWidth: toolDrawerWidth,
        },
        titleText: {
            fontSize: "18px",
            color: "#e0f4ff",
            textTransform: "uppercase",
            margin: "10px 0px 5px",
            fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontWeight: "200",
            textAlign: "left",
        },
        cssLabel: {
            focused: {
                color: "orange",
            },
            cssFocused: {
                color: "orange",
            },
        },
        select: {
            color: "white",
            textAlign: "center",
            focused: {
                color: "orange",
            },
        },
        focused: {},
        roofsheet_chip: {
            // display:"inline",
            borderRadius: chip_width,
            border: "1px solid grey",
            paddingLeft: "0.5rem",
            paddingRight: "0.5rem",
            minWidth: chip_width,
            minHeight: chip_width,
            background: "#fff",
        },
        textBox: {
            width: "100%",
        },
        sliderContainer: {
            // overflow: "hidden"
            // margin: "0px 20px 5px",
        },
        areaHeader: {
            color: "white",
        },
        rowHeaderCell: {
            alignSelf: "center",
            textAlign: "start",
        },
        rowHeader: {},
        rowInputCell: {
            alignSelf: "center",
            textAlign: "start",
        },
    })
);

export default function ShapeJoinTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);

    const SELECTED_POINT = app.designer.designer2D[APP.SELECTED_POINT];

    const [openDialog, setOpenDialog] = React.useState(false);
    const [waitingForPoint, setWaitingForPoint] = React.useState(false);
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [dialogTitle, setDialogTitle] = React.useState("");

    React.useEffect(() => {
        if (waitingForPoint) {
            setWaitingForPoint(false);
            dispatch(update2DDesigner(APP.SELECT_POINT, false));
            let value = "(" + SELECTED_POINT.x + "," + SELECTED_POINT.y + ")";
            updateData("JoinOffsetP", value);
        }
    }, [SELECTED_POINT]);

    const openMessageBox = (title, message) => {
        setDialogTitle(title);
        setDialogMessage(message);
        setOpenDialog(true);
    };

    const { areaIndex } = props;
    const area_design_specs =
        job.AreaSpecifications && job.AreaSpecifications[areaIndex] ? job.AreaSpecifications[areaIndex] : {};
    const next_area_design_specs =
        job.AreaSpecifications && job.AreaSpecifications[areaIndex + 1] ? job.AreaSpecifications[areaIndex + 1] : null;

    const area_design_type = area_design_specs.SHAPE.DesignType;
    const next_area_design_type = next_area_design_specs ? next_area_design_specs.SHAPE.DesignType : "";

    const updateData = (dataField, value) => {
        let error = dispatch(updateAreaSpecificationShape(areaIndex, "AREAJOIN", dataField, value));
        if (error && error.error) {
            // openMessageBox(error?.title, <>{error?.message}</>);

            dispatch(APP.showDialogData(error));
        }
    };

    const updateJoinOffsetP = (x, y) => {
        let value = "(" + x + "," + y + ")";
        updateData("JoinOffsetP", value);
    };

    const getLocation = () => {
        setWaitingForPoint(true);
        dispatch(
            update2DDesigner(
                APP.SELECT_POINT_NOTE,
                <>
                    Click a point on the layout to set the OFFSET POINT of the next area.
                    <br />
                    Right click or press 'ESC' to cancel.
                </>
            )
        );
        dispatch(update2DDesigner(APP.SELECT_POINT, true));
        // dispatch(update2DDesigner(APP.SELECTED_POINT, {x: 0, y: 0}));
    };

    let has_flat = false;
    let has_pitched = false;
    let has_portal = false;
    if ([area_design_type, next_area_design_type].includes(CONFIG.DESIGN_TYPES.FLAT)) has_flat = true;
    if ([area_design_type, next_area_design_type].includes(CONFIG.DESIGN_TYPES.PITCHED)) has_pitched = true;
    if ([area_design_type, next_area_design_type].includes(CONFIG.DESIGN_TYPES.GABLE_PORTAL)) has_portal = true;

    let join_type = "flat_to_flat";
    if (has_flat && has_pitched) join_type = "flat_to_gable";
    if (has_flat && has_portal) join_type = "flat_to_portal";
    if (!has_flat && !has_pitched && has_portal) join_type = "portal_to_portal";
    if (!has_flat) join_type = "portal_to_portal";

    let join_options = [];

    const join_types = window.LYSAGHT ? CONFIG?.JOIN_TYPES_LYSAGHT : CONFIG?.JOIN_TYPES;
    for (let key in join_types) {
        var item = join_types[key];
        if (item[join_type] === true) {
            join_options.push({
                Key: key,
                Display: (
                    <>
                        <Icon className={classes.iconRoot}>
                            <img alt="sheet thumb" src={item[CONFIG.JOIN_TYPE.THUMBNAIL]} style={{ width: "24px" }} />
                        </Icon>
                        {item[CONFIG.JOIN_TYPE.DESCRIPTION]}
                    </>
                ),
            });
        }
    }

    let AreaJoinParameters = area_design_specs.SHAPE.AREAJOIN;
    let this_jointype = AreaJoinParameters.JoinType;
    const selected_join_type = join_types[this_jointype];

    let frontRightEnabled = area_design_specs?.SHAPE?.CUTOUTS?.["FrontRight-CutoutType"] !== "None";
    let backRightEnabled = area_design_specs?.SHAPE?.CUTOUTS?.["BackRight-CutoutType"] !== "None";
    let max_offset_1 = area_design_specs?.SHAPE?.Depth;
    if (area_design_specs?.SHAPE?.RotateArea === 1) max_offset_1 = area_design_specs?.SHAPE?.Length;
    if (frontRightEnabled) max_offset_1 -= toNumber(area_design_specs?.SHAPE?.CUTOUTS?.["FrontRight-WidthY"]);
    if (backRightEnabled) max_offset_1 -= toNumber(area_design_specs?.SHAPE?.CUTOUTS?.["BackRight-WidthY"]);

    let next_backLeftEnabled = next_area_design_specs?.SHAPE?.CUTOUTS?.["BackLeft-CutoutType"] !== "None";
    let next_frontLeftEnabled = next_area_design_specs?.SHAPE?.CUTOUTS?.["FrontLeft-CutoutType"] !== "None";
    let max_offset_2 = next_area_design_specs?.SHAPE?.Depth;
    if (next_area_design_specs?.SHAPE?.RotateArea === 1) max_offset_2 = next_area_design_specs?.SHAPE?.Length;
    if (next_frontLeftEnabled) max_offset_2 -= toNumber(next_area_design_specs?.SHAPE?.CUTOUTS?.["FrontLeft-WidthY"]);
    if (next_backLeftEnabled) max_offset_2 -= toNumber(next_area_design_specs?.SHAPE?.CUTOUTS?.["BackLeft-WidthY"]);

    let offsetP = AreaJoinParameters.JoinOffsetP.split(",");
    let join_offset_x = toNumber(offsetP[0]);
    let join_offset_y = toNumber(offsetP[1]);

    return (
        <div className={classes.root} key={areaIndex + 0.5}>
            <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>JOIN TYPE</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow>
                    <SegmentedButtonGroup
                        tight
                        vertical
                        value={AreaJoinParameters?.JoinType}
                        items={join_options}
                        ButtonStyle={{
                            justifyContent: "start",
                        }}
                        onChange={(e, val) => updateData("JoinType", val)}
                    />
                </BSL_Common.SectionRow>
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>JOIN OPTIONS</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                {selected_join_type?.show_angle && (
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Join Angle"
                            value={AreaJoinParameters?.JoinAngle}
                            tight
                            min={-95}
                            max={135}
                            endAdornment="°"
                            style={{ maxWidth: "100px" }}
                            onBlur={(val) => updateData("JoinAngle", val)}
                        />
                    </BSL_Common.SectionRow>
                )}
                {selected_join_type?.show_offset && (
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Join Offset"
                            value={AreaJoinParameters?.JoinOffset}
                            tight
                            min={-max_offset_1}
                            max={isNaN(max_offset_2) ? 9999 : Number(max_offset_2)}
                            endAdornment="mm"
                            style={{ maxWidth: "100px" }}
                            onBlur={(val) => updateData("JoinOffset", val)}
                        />
                    </BSL_Common.SectionRow>
                )}

                {this_jointype === "Gable" && (
                    <BSL_Common.SectionRow>
                        <BSL_CheckBox
                            checked={Number(area_design_specs.SHAPE.AREAJOIN.JoinAngle) === -90}
                            label="Reverse Gable Turn"
                            onChange={(checked) => updateData("JoinAngle", checked ? -90 : 90)}
                        />
                    </BSL_Common.SectionRow>
                )}
                {this_jointype === "Hip" && (
                    <BSL_Common.SectionRow>
                        <BSL_CheckBox
                            checked={Number(area_design_specs.SHAPE.AREAJOIN.JoinAngle) === -90}
                            label="Reverse Hip Turn"
                            onChange={(checked) => updateData("JoinAngle", checked ? -90 : 90)}
                        />
                    </BSL_Common.SectionRow>
                )}

                {(this_jointype !== "Offset") & (this_jointype !== "None") && (
                    <BSL_Common.SectionRow>
                        <BSL_CheckBox
                            checked={job?.DesignParameters?.UseAreaJoinExtensions}
                            label="Extend Area Length into Join Area (all areas)"
                            onChange={(checked) => {
                                console.log("UseAreaJoinExtensions", checked);
                                dispatch(
                                    updateJobState(UPDATE_DESIGN_PARAMETERS, "UseAreaJoinExtensions", checked, false)
                                );
                            }}
                        />
                    </BSL_Common.SectionRow>
                )}
                {this_jointype === "None" && (
                    <>
                        <BSL_Common.SectionRow>
                            <BSL_TextInput
                                label="Join Angle"
                                value={AreaJoinParameters?.JoinAngle}
                                tight
                                min={-180}
                                max={180}
                                endAdornment="°"
                                style={{ maxWidth: "100px" }}
                                onBlur={(val) => updateData("JoinAngle", val)}
                            />
                        </BSL_Common.SectionRow>

                        <BSL_Common.SectionRow
                            style={{
                                alignItems: "center",
                            }}
                        >
                            <BSL_TextInput
                                preValidate="numeric"
                                label="Offset Point X"
                                value={join_offset_x}
                                tight
                                endAdornment="mm"
                                style={{ maxWidth: "100px" }}
                                onBlur={(val) => updateJoinOffsetP(val, join_offset_y)}
                            />
                            <BSL_TextInput
                                preValidate="numeric"
                                label="Offset Point Y"
                                value={join_offset_y}
                                tight
                                endAdornment="mm"
                                style={{ maxWidth: "100px" }}
                                onBlur={(val) => updateJoinOffsetP(join_offset_x, val)}
                            />
                            {!app.designer.threeDMode && (
                                <BSL_Button
                                    onClick={getLocation}
                                    style={{
                                        marginLeft: "20px",
                                        maxHeight: "29px",
                                    }}
                                >
                                    <ControlCameraIcon />
                                </BSL_Button>
                            )}
                        </BSL_Common.SectionRow>
                    </>
                )}
            </BSL_Common.SectionContainer>

            <BSL_Dialog
                title={dialogTitle}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                button1Text="Close"
                button1Click={() => setOpenDialog(false)}
            >
                {dialogMessage}
            </BSL_Dialog>
        </div>
    );
}

// export default connect(mapStateToProps, importedActions)(withStyles(styles)(ShapeJoinTools));
